import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/seo/SEO";

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center app-surface bg-dot-grid p-4">
      <SEO
        title="Payment cancelled — Email2Contact"
        description="Your Email2Contact payment was cancelled. No charges have been made. You can return to your settings or contact support."
        path="/payment-cancelled"
        noindex
      />
      <div className="app-tile max-w-md w-full p-10 text-center animate-fade-in-up">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-amber-500/10 ring-1 ring-amber-500/20 flex items-center justify-center">
            <XCircle className="h-9 w-9 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <h1 className="text-3xl font-display font-semibold mb-3 tracking-tight">Payment cancelled</h1>

        <p className="text-muted-foreground mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div className="rounded-lg border border-border bg-muted/40 p-4 mb-6">
          <p className="text-sm text-muted-foreground">
            If you experienced any issues during checkout, please contact our support team.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button onClick={() => navigate('/settings')} className="w-full shadow-fluent-2">
            Try again
          </Button>
          <Button variant="outline" onClick={() => navigate('/')} className="w-full">
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
